var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 90.019 72.0023",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64073 0.305999C4.44023 0.881999 2.45123 2.421 1.18673 4.5405C-0.0687674 6.633 -0.00576744 4.968 0.00323256 36.1035C0.0122326 62.0145 0.0392319 64.2375 0.322732 65.331C1.13273 68.4315 3.86423 71.055 6.96473 71.712C8.79623 72.099 81.1922 72.099 83.0237 71.712C84.6932 71.361 85.9082 70.668 87.2987 69.282C88.6847 67.8915 89.3777 66.6765 89.7287 65.007C90.1157 63.1845 90.1157 8.7705 89.7287 6.948C89.0717 3.8475 86.4482 1.116 83.3477 0.305999C82.2497 0.0179993 79.5497 0 44.9942 0C10.4387 0 7.73873 0.0179993 6.64073 0.305999ZM80.7197 9.324C80.0717 9.9495 45.1022 39.0375 44.9942 39.0375C44.8862 39.0375 9.91673 9.9495 9.26873 9.324C8.91773 8.982 9.41723 8.9775 44.9942 8.9775C80.5712 8.9775 81.0707 8.982 80.7197 9.324ZM25.5362 34.6275C36.5747 43.8165 41.5697 47.862 42.2762 48.195C43.1447 48.6 43.5227 48.6675 44.9942 48.6675C46.4657 48.6675 46.8437 48.6 47.7122 48.195C48.4187 47.862 53.4137 43.8165 64.4522 34.6275C73.1057 27.423 80.3642 21.3615 80.5892 21.159L80.9942 20.7945V62.9775H8.99423V20.7945L9.39923 21.159C9.61973 21.3615 16.8827 27.423 25.5362 34.6275Z",
    fill: "var(--fill-0, #10161F)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.fe9482990b7a0bc46aaf3ec8d9165e22.svg";
export { ForwardRef as ReactComponent };